/* Centralised access to Vite env vars with safe defaults. Keeping this in one
 * place makes it easy to verify the build at a glance.
 *
 * IMPORTANT — CORS: api.hofj.com responds 200 but does not echo the request
 * origin in `Access-Control-Allow-Origin`, so direct browser calls are blocked.
 * In dev/preview we route via Vite's HTTP proxy under /__api/hofj. For
 * production we still call api.hofj.com directly: this only works if the
 * deploy origin is whitelisted on the API or fronted by a serverless proxy.
 */

const env = import.meta.env;

const PROD_API_BASE = (env.VITE_HOFJ_API_BASE ?? 'https://api.hofj.com').replace(
  /\/$/,
  '',
);

/** Base URL used by api/client.ts. Empty string in dev → relative paths so the
 * Vite proxy under /__api/hofj handles the request. */
export const apiBase = env.DEV ? '/__api/hofj' : PROD_API_BASE;
export const apiKey = env.VITE_HOFJ_API_KEY ?? 'dev-internal-api-key';
export const brand = env.VITE_HOFJ_BRAND ?? 'weebora.com';
export const locale = env.VITE_LOCALE ?? 'it';

const PROD_BOOKING_BASE = (env.VITE_BOOKING_BASE ?? 'https://booking.hofj.com').replace(
  /\/$/,
  '',
);

/** Base URL used by api/booking.ts. Routed through the dev proxy locally. */
export const bookingBase = env.DEV ? '/__api/booking' : PROD_BOOKING_BASE;
export const bookingItineraryPath =
  env.VITE_BOOKING_ITINERARY_PATH ?? '/api/itinerary';
export const bookingCheckoutPath =
  env.VITE_BOOKING_CHECKOUT_PATH ?? '/checkout';
export const affiliateId = env.VITE_AFFILIATE_ID ?? 'wansport';

/** Locale used as URL prefix on booking.hofj.com (e.g. /it, /en). Falls back
 * to the first segment of VITE_LOCALE when it's a full IETF tag like it-IT.
 */
export const bookingLocale = locale.split('-')[0]?.toLowerCase() ?? 'it';

/** Fully-qualified production URL of the booking host. Used to build the
 * absolute checkout URL we redirect to (the WebView leaves the whitelabel and
 * lands on booking.hofj.com for the rest of the flow). */
export const productionBookingBase = PROD_BOOKING_BASE;

export const intlLocale = locale.includes('-') ? locale : `${locale}-${locale.toUpperCase()}`;
